import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-collapsable-row',
    templateUrl: './collapsable-row.component.html',
    styleUrls: ['./collapsable-row.component.scss'],
    host: { class: 'apc-collapsable-row' },
    standalone: false
})
export class CollapsableRowComponent implements OnInit {
  @Input() public section: string;
  @Input() public type: string;
  @Input() public index: number;
  @Input() public imgSrc: string | null | undefined = null;
  @Input() public title: string;
  @Input() public isCollapsed: boolean;
  @Input() public isClosable: boolean = true;
  @Input() public titleIsUpperCase: boolean = false;
  @Input() public isModal: boolean = false;
  @Input() public isEdit: boolean = false;
  @Output() collapseEvent = new EventEmitter<any>();

  public id: string = '';

  ngOnInit(): void {
    this.initComponent();
  }

  initComponent(){
    if (this.isModal) {
      this.id = this.section + '-' + this.type + '-modal-row-' + this.index;
    } else {
      this.id = this.section + '-row-' + this.index;
    }
  }

  collapse(e) {
    if (
      e.target.classList.contains('information') ||
      e.target.parentElement?.classList.contains('information') ||
      e.target.parentElement?.parentElement?.classList.contains('information')
    ) {
      if(!this.isEdit) {
      if (this.isClosable) this.isCollapsed = true;
      this.collapseEvent.emit(this.collapseEvent);
      }
    }
  }

  collapseRow() {
    if (!this.isCollapsed && this.isClosable)
      this.isCollapsed = true;
    else
      this.isCollapsed = !this.isCollapsed;
    !this.isEdit && this.collapseEvent.emit(this.collapseEvent);
  }
}
